var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chargingTime1"},[_c('title1',{attrs:{"type":"1","title":"告警等级占比","subTitle":"Electric Port Overview","right":true},scopedSlots:_vm._u([{key:"uuid",fn:function(){return undefined},proxy:true}])}),_c('div',{ref:"piethree",staticClass:"pieon3",attrs:{"id":"pieon3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }